export default __webpack_public_path__ + "static/media/frontEnd.8029a00e.jpg";